import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=33a5a43f&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"
import style0 from "./Profile.vue?vue&type=style&index=0&id=33a5a43f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a5a43f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SwitchIcon: require('C:/app/components/Svgs/SwitchIcon.vue').default,Logout: require('C:/app/components/Svgs/Logout.vue').default,Exchange: require('C:/app/components/Svgs/Exchange.vue').default})
